import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { MdClose, MdCheck } from "react-icons/md";
import FieldError from "../../../shared/FieldError";
import FileUploader from "../FileUploader";
import ReactDatePicker from "react-datepicker";
import { BsClockFill, BsFillCalendarEventFill } from "react-icons/bs";
import MeasuredAtDatePicker from "./MeasuredAtDatePicker";
import * as Helpers from "../../../helpers";
const FastingGlucose = ({ data, handleField }) => {
  const FastingGlucoseSchema = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .matches(/^\d*\.{1}\d*$/, "value must be a floating point (decimal)"),
  });

  return (
    <div className={'m-t-lg'}>
      <Formik
        initialValues={{
          data: data.value,
          measured_at_date: data.measured_at_date,
        }}
        validationSchema={FastingGlucoseSchema}
        validateOnChange={true}
        onSubmit={async (values) => {
          let measuredAtDate = values.measured_at_date &&  values.measured_at_date instanceof Date ? Helpers.formatMMDDYYYY(values.measured_at_date) : null;

          const request = await handleField({
            id: data.id,
            cpr_id: data.cprId,
            document: values.document,
            value: values.data,
            measured_at_date: measuredAtDate,
            quality_measurement_type_id: data.quality_measurement_type_id,
          });
        }}
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <div className={'m-t-lg'}>
              <Form>
                <label>
                  Fasting Glucose <span id="from">(Metabolic Screening)</span>
                </label>
                <input
                  className="default"
                  placeholder="e.g. 5.23"
                  value={values.data}
                  onChange={(e) => {
                    setFieldValue("data", e.target.value);
                  }}
                />
                {errors.data ? <FieldError error={errors.data} /> : null}
                <MeasuredAtDatePicker value={values.measured_at_date} setFieldValue={setFieldValue} />
                <FileUploader data={data} setFieldValue={setFieldValue} />
                {handleField && ((initialValues.data !== values.data && !errors.data) || (values.document) || (values.measured_at_date != null && values.measured_at_date != data.measured_at_date)) && (
                  <div className="check-cancel-buttons flex">
                    <button className="check small" type="submit">
                      <MdCheck className="check-icon" />
                    </button>
                    <button
                      className="cancel small"
                      onClick={() => {
                        initialValues.data
                          ? setFieldValue("data", initialValues.data)
                          : setFieldValue("data", "");
                      }}
                    >
                      <MdClose className="cancel-icon" />
                    </button>
                  </div>
                )}
              </Form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default FastingGlucose;
